import { useTokenizedApi } from '../useTokenizedApi';
import { useQuery } from 'react-query';

/** @category Entities and Profiles */
export function usePersonalProfile() {
  const tokenizedApi = useTokenizedApi();
  const profiles = useQuery(tokenizedApi.entities.profilesQuery());
  return profiles?.data?.personalProfile;
}
